import { SVGProps } from 'react';

const SvgAddPerson = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" {...props}>
        <path d="M12.555 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 1.663a1.837 1.837 0 1 1 0 3.674 1.837 1.837 0 0 1 0-3.674Zm-9.625.962V5.25H.305V7H2.93v2.625h1.75V7h2.625V5.25H4.68V2.625H2.93Zm9.625 5.25c-2.336 0-7 1.164-7 3.5V14h14v-2.625c0-2.336-4.664-3.5-7-3.5Zm0 1.662c2.599 0 5.338 1.278 5.338 1.838v.963H7.218v-.963c0-.56 2.712-1.838 5.337-1.838Z" />
    </svg>
);
export default SvgAddPerson;
